export default __webpack_public_path__ + "static/media/IMG-20240729-WA0015.748a83e8.jpg";